import * as React from 'react';

import { cn } from '../../lib/utils';

interface InputProps extends React.ComponentProps<'input'> {
    /** Default filled gray matches most form fields; `outlined` is for primary hero fields on white (e.g. agreement name). */
    variant?: 'filled' | 'outlined';
}

const inputBaseClasses =
    'flex h-9 w-full rounded-md px-3 py-1 text-base font-normal shadow-none transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-neutral-500 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-neutral-950 focus-visible:ring-offset-0 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm';

const inputVariantClasses: Record<NonNullable<InputProps['variant']>, string> = {
    filled: 'border-0 admin-field-fill text-neutral-900 file:text-neutral-900 focus-visible:border-transparent dark:text-neutral-100 dark:placeholder:text-neutral-400 dark:file:text-neutral-100',
    outlined:
        'border border-neutral-300 bg-white text-neutral-900 file:text-neutral-900 focus-visible:border-neutral-400 dark:border-neutral-600 dark:bg-neutral-950 dark:text-neutral-50 dark:placeholder:text-neutral-400 dark:file:text-neutral-50',
};

const Input = React.forwardRef<HTMLInputElement, InputProps>(
    ({ className, type, variant = 'filled', onWheel, ...props }, ref) => {
        return (
            <input
                type={type}
                className={cn(inputBaseClasses, inputVariantClasses[variant], className)}
                ref={ref}
                onWheel={(event) => {
                    onWheel?.(event);
                    if (type === 'number' && !event.defaultPrevented) {
                        event.currentTarget.blur();
                    }
                }}
                {...props}
            />
        );
    },
);
Input.displayName = 'Input';

export { Input };
